import { HomeScreen } from "@/screens/HomeScreen";

const Index = () => {
  return <HomeScreen />;
};

export default Index;
